export const AppRoutes = {
  '404': '/404',
  wc: '/wc',
  terms: '/terms',
  privacy: '/privacy',
  licenses: '/licenses',
  index: '/',
  imprint: '/imprint',
  home: '/home',
  badges: {
    allTime: '/badges',
    season7: '/badges/season-7',
    season8: '/badges/season-8',
  },
  campaigns: '/campaigns',
  cookie: '/cookie',
  contacts: '/contacts',
  addOwner: '/addOwner',
  _offline: '/_offline',
  sunnyClaim: '/airdrop',
  leaderboard: { index: '/leaderboard', season7: '/leaderboard/season-7' },
  apps: {
    open: '/apps/open',
    index: '/apps',
    custom: '/apps/custom',
    bookmarked: '/apps/bookmarked',
  },
  vaults: {
    index: '/vaults',
  },
  balances: {
    nfts: '/balances/nfts',
    index: '/balances',
  },
  newSafe: {
    load: '/new-safe/load',
    create: '/new-safe/create',
  },
  invites: '/invites',
  settings: {
    setup: '/settings/setup',
    securityLogin: '/settings/security-login',
    notifications: '/settings/notifications',
    modules: '/settings/modules',
    index: '/settings',
    environmentVariables: '/settings/environment-variables',
    data: '/settings/data',
    cookies: '/settings/cookies',
    appearance: '/settings/appearance',
    safeApps: {
      index: '/settings/safe-apps',
    },
  },
  share: {
    safeApp: '/share/safe-app',
  },
  transactions: {
    tx: '/transactions/tx',
    queue: '/transactions/queue',
    messages: '/transactions/messages',
    index: '/transactions',
    history: '/transactions/history',
  },
  welcome: {
    socialLogin: '/welcome/social-login',
    index: '/welcome',
    accounts: '/welcome/accounts',
  },
}
